import React from "react";
import { Search } from "lucide-react";
import Container from "@/components/marketing/Container";
import HeroBackground from "@/components/marketing/HeroBackground";

/**
 * Compact dark hero for the Help Centre. Uses the site's standard
 * architectural texture (HeroBackground) on the dark frame band, with
 * the search field moved inside the hero. Straight edge into the light
 * body below.
 */
export default function HelpHero({ search, onSearchChange }) {
  return (
    <section className="relative bg-frame pt-28 lg:pt-32 pb-24 lg:pb-32 overflow-hidden">
      <HeroBackground />
      <Container className="relative text-center">
        <span className="meta-tag inline-block mb-5 rounded-full border-[#3a3352] text-[#8a86a8]">
          Help Centre
        </span>
        <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
          How can we help?
        </h1>
        <p className="text-[#b7b3cc] max-w-xl mx-auto mb-8 leading-relaxed">
          Find answers about the Digital24 platform, placing orders, and press release distribution.
        </p>
        <div className="relative max-w-xl mx-auto">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-steel/60 pointer-events-none" />
          <input
            type="text"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Search for a question or topic..."
            className="w-full pl-12 pr-4 py-3.5 rounded-lg border border-[#e8e6ef] bg-white text-bone placeholder:text-steel/60 focus:outline-none focus:border-cobalt focus:ring-2 focus:ring-cobalt/20 transition-colors"
          />
        </div>
      </Container>
    </section>
  );
}